import { render, staticRenderFns } from "./microRecommendation.vue?vue&type=template&id=531c5686&scoped=true"
import script from "./microRecommendation.vue?vue&type=script&lang=js"
export * from "./microRecommendation.vue?vue&type=script&lang=js"
import style0 from "./microRecommendation.vue?vue&type=style&index=0&id=531c5686&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531c5686",
  null
  
)

export default component.exports